import DepreciationList from 'components/reports/ReportsDepreciationList';
import DepreciationRow from 'components/reports/ReportsDepreciationRow';

export default { DepreciationList, DepreciationRow };



// WEBPACK FOOTER //
// src/components/reports/index.js